import { Link } from "react-router-dom";
import styled from "styled-components";
import COLOURS from "../../../variables/colours";

export const StyledProjectNavigation = styled.nav`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-radius: 25px;
  border: 1px solid black;
  margin-top: 2.5%;
  width: 88vw;
`;

export const StyledLink = styled(Link)`
  flex-grow: 1;
  text-align: center;
  color: black;
  transition: 0.25s;
  background-color: ${(props) => (props.isActive ? COLOURS.pink : "")};
  color: ${(props) => (props.isActive ? "white" : "black")};
  text-decoration: none;
  &:first-child {
    border-right: 1px solid black;
    border-radius: 24px 0px 0px 24px;
  }
  &:nth-child(2) {
  }
  &:nth-child(3) {
    border-radius: 0px 24px 24px 0px;
    border-left: 1px solid black;
  }

  &:hover {
    background-color: ${COLOURS.pink};
    color: white;
  }

  > p {
    padding-top: 10px;
    font-size: 25px;
  }
`;
